import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-assignment-row',
  templateUrl: './assignment-row.component.html',
  styleUrls: ['./assignment-row.component.scss']
})
export class AssignmentRowComponent implements OnInit {

  @Input('singleLearner') learner: any;
  @Input('singleUnit') unit
  @Input('hoverIndex') hoverIndexValue;
  @Input('assignments') assignmentList
  @Input('allotment') allotmentArray
  @Input('elementSelected') selecElement
  @Input('elementRemove') removeElement
  @Input('displayType') selectedType
  @Input('singleQuiz') quiz
  @Input('singleJobDetails') singleJob
  @Output() learnerAllotments: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedAssignment: EventEmitter<any> = new EventEmitter<any>();
  allLearners = []
  user
  selectedUnit
  assignmentData = []
  singleLearner
  allotments = []
  elementSelection
  removedElement = []
  newType
  hoverIndex
  oneQuiz
  jobData
  constructor() { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))

  }


  ngOnChanges(changes: SimpleChanges): void {
    // console.log("here it is for first part", changes);
    if(changes.singleJob) this.jobData = changes.singleJob.currentValue
    
    if (changes.learner && changes.learner.currentValue) this.singleLearner = changes.learner.currentValue

    if (changes.unit && changes.unit.currentValue) this.selectedUnit = changes.unit.currentValue

    if (changes.assignmentList && changes.assignmentList.currentValue) this.assignmentData = changes.assignmentList.currentValue
    
    if (changes.hoverIndexValue && (changes.hoverIndexValue.currentValue != null || undefined)) this.hoverIndex = changes.hoverIndexValue.currentValue
    
    if (changes.allotmentArray && changes.allotmentArray.currentValue) this.allotments = changes.allotmentArray.currentValue

    if (changes.selecElement && changes.selecElement.currentValue) this.elementSelection = changes.selecElement.currentValue

    if (changes.removeElement && changes.removeElement.currentValue) this.removedElement = changes.removeElement.currentValue

    if (changes.selectedType && changes.selectedType.currentValue) this.newType = changes.selectedType.currentValue

    if (changes.quiz && changes.quiz.currentValue) this.oneQuiz = changes.quiz.currentValue

  }

  allotmentList(event) {
    if (event && event.length) this.learnerAllotments.emit(event)
    else this.learnerAllotments.emit([])
  }


  selectedElement(event) {
    if (event && event.length) this.selectedAssignment.emit(event)
    else this.selectedAssignment.emit(event)
  }

}
